import PasswordInstance from "./axiosConfig/passwordConfig";
import AuthUserInstance from "./axiosConfig/authUserConfig";
import FolderInstance from "./axiosConfig/folderConfig";
import NotificationInstance from "./axiosConfig/notificationConfig";
import LogsIntance from "./axiosConfig/logsConfigs";
import PermissionInstance from "./axiosConfig/permissionConfig";
import OwnerShipInstance from "./axiosConfig/ownerShipConfig";
import {
  ALL_USERS,
  ALL_USERS_BY_EMAILS,
  LOGIN,
  USER_BASE_URL,
} from "./urls/authUserUrl";
import {
  CREATE_PASSWORD,
  GET_ALL_PASSWORD,
  GET_A_PASSWORD,
  GET_ENV_PASSWORDS,
  PASSWORD_BASE_URL,
  SHARE_PASSWORD,
  FORWARD_PASSWORD,
  UPLOAD_CSV,
  GLOBAL_SEARCH,
  PW_DETAILS,
  GET_FOLDER_PASSWORDS,
} from "./urls/passwordUrl";
import {
  FOLDER_BASE_URL,
  FOLDER_DETAILS,
  GET_FOLDER_ENVS,
  SHARE_ENV_LIST,
  SHARE_FOLDER,
} from "./urls/folderUrl";
import {
  GET_ENV_PERMISSION_LIST,
  GET_FOLDER_PERMISSION_LIST,
  GET_PASSWORD_PERMISSION_LIST,
  PERMISSION_BASE_URL,
} from "./urls/permissionUrl";
import { CHANGE_OWNERSHIP } from "./urls/ownerShipUrl";
import { encrypt, decrypt } from "../Utils/crypto.utils";
import { NOTIFICATION_BASE_URL } from "./urls/notificationUrl";
import { LOGS_BASE_URL } from "./urls/logsUrl";

const headers = {
  headers: {
    "Access-Control-Allow-Origin": "*",
    Accept: "application/json",
    "Content-Type": "application/json",
  },
};

export const ApiCallGateway = {
  user: {
    login: async (request) => {
      const response = await AuthUserInstance.post(
        LOGIN,
        request,
        headers
      );
      return response;
    },
    allUsers: async (searchString, limit, page) => {
      const response = await AuthUserInstance.get(ALL_USERS, {
        headers,
        params: {
          name: searchString,
          limit: limit,
          page: page,
        },
      });
      return response;
    },
    allUsersByEmails: async (emails) => {
      const response = await AuthUserInstance.get(
        ALL_USERS_BY_EMAILS,
        {
          headers,
          params: {
            emails: emails,
          },
        }
      );
      return response;
    },
    updateUser: async (request, userId) => {
      const response = await AuthUserInstance.patch(
        USER_BASE_URL,
        request,
        {
          headers,
          params: { userId: userId },
        }
      );
      return response;
    },
    getUsersPassword: async (userId, created, identifier) => {
      const response = await AuthUserInstance.get(USER_BASE_URL, {
        headers,
        params: {
          userId: userId,
          created: created,
          identifier: identifier,
        },
      });
      return response;
    },
  },
  password: {
    createPassword: async (request) => {
      const Enc = encrypt(request);
      const body = { EncData: Enc };
      const response = await PasswordInstance.post(
        CREATE_PASSWORD,
        body,
        {
          withCredentials: true,
          headers,
        }
      );
      return response;
    },
    getAPassword: async (passwordId) => {
      const response = await PasswordInstance.get(GET_A_PASSWORD, {
        headers,
        params: { passwordId: passwordId },
      });
      return response;
    },
    getAPasswordDetails: async (passwordId) => {
      const response = await PasswordInstance.get(PW_DETAILS, {
        headers,
        params: { passwordId: passwordId },
      });
      return response;
    },
    getAllPassword: async (page, viewUserId) => {
      const response = await PasswordInstance.get(GET_ALL_PASSWORD, {
        headers,
        params: {
          identifier: "",
          page: page,
          viewUserId: viewUserId,
        },
      });
      return response;
    },
    sharePassword: async (request) => {
      const response = await PasswordInstance.post(
        SHARE_PASSWORD,
        request,
        headers
      );
      return response;
    },
    searchPassword: async (searchString) => {
      const response = await PasswordInstance.get(GLOBAL_SEARCH, {
        headers,
        params: {
          searchString: searchString,
        },
      });
      return response;
    },
    getAllSharePassword: async (page, viewUserId) => {
      const response = await PasswordInstance.get(SHARE_PASSWORD, {
        headers,
        params: {
          page: page,
          viewUserId: viewUserId,
        },
      });
      return response;
    },
    deletePassword: async (passwordId) => {
      const response = await PasswordInstance.delete(
        PASSWORD_BASE_URL,
        {
          headers,
          params: { passwordId: passwordId },
        }
      );
      return response;
    },
    updatePassword: async (request, passwordId) => {
      const Enc = encrypt(request);
      const body = { EncData: Enc };
      const response = await PasswordInstance.patch(
        PASSWORD_BASE_URL,
        body,
        {
          headers,
          params: { passwordId: passwordId },
        }
      );
      return response;
    },
    getEnvPasswords: async (envId, viewUserId) => {
      const response = await PasswordInstance.get(GET_ENV_PASSWORDS, {
        headers,
        params: { envId: envId, viewUserId: viewUserId },
      });
      return response;
    },
    getFolderPasswords: async (folderId, viewUserId) => {
      const response = await PasswordInstance.get(
        GET_FOLDER_PASSWORDS,
        {
          headers,
          params: { folderId: folderId, viewUserId: viewUserId },
        }
      );
      return response;
    },
    forwardPassword: async (request) => {
      const response = await PasswordInstance.post(
        FORWARD_PASSWORD,
        request,
        headers
      );
      return response;
    },
    uploadCsv: async (request) => {
      const response = await PasswordInstance.post(
        UPLOAD_CSV,
        request,
        headers
      );
      return response;
    },
  },
  folder: {
    createFolderEnv: async (request, isEnv) => {
      const response = await FolderInstance.post(
        FOLDER_BASE_URL,
        request,
        {
          headers,
          params: { isEnv: isEnv },
        }
      );
      return response;
    },
    getAllFolders: async (page, viewUserId) => {
      const response = await FolderInstance.get(FOLDER_BASE_URL, {
        headers,
        params: {
          page: page,
          viewUserId: viewUserId,
        },
      });
      return response;
    },
    getAFoldersEnvs: async (folderId) => {
      const response = await FolderInstance.get(GET_FOLDER_ENVS, {
        headers,
        params: { folderId: folderId },
      });
      return response;
    },
    getAFoldersDetails: async (folderId) => {
      const response = await FolderInstance.get(FOLDER_DETAILS, {
        headers,
        params: { id: folderId },
      });
      return response;
    },
    getAllShareFolders: async (page, viewUserId) => {
      const response = await FolderInstance.get(SHARE_FOLDER, {
        headers,
        params: {
          page: page,
          viewUserId: viewUserId,
        },
      });
      return response;
    },
    getAllShareEnvs: async (page, viewUserId) => {
      const response = await FolderInstance.get(SHARE_ENV_LIST, {
        headers,
        params: {
          page: page,
          viewUserId: viewUserId,
        },
      });
      return response;
    },
    shareFolderEnv: async (request, isEnv) => {
      const response = await FolderInstance.post(
        SHARE_FOLDER,
        request,
        {
          headers,
          params: { isEnv: isEnv },
        }
      );
      return response;
    },
    deleteFolderEnv: async (id) => {
      const response = await FolderInstance.delete(FOLDER_BASE_URL, {
        headers,
        params: { id: id },
      });
      return response;
    },
    updateFolderEnv: async (request, folderId) => {
      const response = await FolderInstance.patch(
        FOLDER_BASE_URL,
        request,
        {
          headers,
          params: { folderId: folderId },
        }
      );
      return response;
    },
  },
  permission: {
    createPermision: async (request) => {
      const response = await PermissionInstance.post(
        PERMISSION_BASE_URL,
        request,
        headers
      );
      return response;
    },
    getFolderPermission: async (folderId) => {
      const response = await PermissionInstance.get(
        GET_FOLDER_PERMISSION_LIST,
        {
          headers,
          params: { folderId: folderId },
        }
      );
      return response;
    },
    getPasswordPermission: async (passwordId, envId, folderId) => {
      const response = await PermissionInstance.get(
        GET_PASSWORD_PERMISSION_LIST,
        {
          headers,
          params: {
            passwordId: passwordId,
            envId: envId,
            folderId: folderId,
          },
        }
      );
      return response;
    },
    updatePermission: async (request, permissionId) => {
      const response = await PermissionInstance.patch(
        PERMISSION_BASE_URL,
        request,
        {
          headers,
          params: { permissionId: permissionId },
        }
      );
      return response;
    },
    deletePermission: async (sharedId, permissionId) => {
      const response = await PermissionInstance.delete(
        PERMISSION_BASE_URL,
        {
          headers,
          params: { sharedId: sharedId, permissionId: permissionId },
        }
      );
      return response;
    },
    getEnvPermissionList: async (envId, folderId) => {
      const response = await PermissionInstance.get(
        GET_ENV_PERMISSION_LIST,
        {
          headers,
          params: { envId: envId, folderId: folderId },
        }
      );
      return response;
    },
  },
  ownerShip: {
    changeOwner: async (request) => {
      const response = await OwnerShipInstance.post(
        CHANGE_OWNERSHIP,
        request,
        headers
      );
      return response;
    },
  },
  notification: {
    getAllNotifications: async () => {
      const response = await NotificationInstance.get(
        NOTIFICATION_BASE_URL,
        headers
      );
      return response;
    },
    readNotifications: async () => {
      const response = await NotificationInstance.patch(
        NOTIFICATION_BASE_URL,
        {},
        {
          withCredentials: true,
          headers,
        }
      );
      return response;
    },
  },
  logs: {
    getLogs: async (dataId, action, pageNumber, userId) => {
      const response = await LogsIntance.get(LOGS_BASE_URL, {
        headers,
        params: {
          dataId: dataId,
          action: action,
          pageNumber: pageNumber || 1,
          userId,
        },
      });
      return response;
    },
  },
};
